import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import type { HTMLAttributes } from 'vue';
    import { cn } from '@/lib/utils';
    import { Button } from '@/components/ui/button';
    import { PanelLeft } from 'lucide-vue-next';
    import { useSidebar } from './utils';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'SidebarTrigger',
  props: {
    class: {}
  },
  setup(__props: any) {

    const props = __props;

    const { toggleSidebar } = useSidebar();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Button), {
    "data-sidebar": "trigger",
    "data-slot": "sidebar-trigger",
    variant: "ghost_primary",
    size: "icon",
    class: _normalizeClass(_unref(cn)('mr-2 h-7 w-7', props.class)),
    onClick: _unref(toggleSidebar)
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(PanelLeft)),
      _cache[0] || (_cache[0] = _createElementVNode("span", { class: "sr-only" }, "Toggle Sidebar", -1))
    ]),
    _: 1,
    __: [0]
  }, 8, ["class", "onClick"]))
}
}

})